import React from 'react';
import Layout from '../components/Layout';

const DataPenerbit = () => {
  return (
    <Layout title="Data Penerbit">
      <h2 className="title is-4">Halaman Data Anggota</h2>
      <p>Ini adalah halaman untuk menampilkan dan mengelola data anggota.</p>
    </Layout>
  );
};

export default DataPenerbit;